import { render, staticRenderFns } from "./Updatepwd.vue?vue&type=template&id=cd4e1c42&scoped=true"
import script from "./Updatepwd.vue?vue&type=script&lang=js"
export * from "./Updatepwd.vue?vue&type=script&lang=js"
import style0 from "./Updatepwd.vue?vue&type=style&index=0&id=cd4e1c42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd4e1c42",
  null
  
)

export default component.exports